import { H3, Card } from "@blueprintjs/core";
import { Fragment } from "react";
import "./TeamMemberCard.scss";

interface TeamProps {
  link?: string;
  photo: any;
  name: string;
  role?: string;
  description?: string;
}

const renderMemberInfo = (photo: any, name: string, role: string | undefined, description: string | undefined) => {
  return (
    <Fragment>
      <div className="img-container">
        <img src={photo} alt="" />
      </div>
      <H3> {name}</H3>
      <p>{role}</p>
      <p>{description}</p>
    </Fragment>
  );
};

export default function TeamMemberCard(member: TeamProps) {
  const { link, photo, name, role, description } = member;
  if (link) {
    return (
      <Card className="team-member">
        <a className="member-info" href={link} target="_blank" rel="noreferrer">
          {renderMemberInfo(photo, name, role, description)}
        </a>
      </Card>
    );
  } else {
    return (
      <Card className="team-member">
        <div className="member-info">{renderMemberInfo(photo, name, role, description)}</div>
      </Card>
    );
  }
}
